import React, { useState, useEffect } from "react";
import StoryFinishModal from "./StoryFinishModal";
import { getStorage, ref, getBytes } from "firebase/storage";
import "./StoryQuiz.css";

export default function StoryQuiz({ storyId, story, quizUrl, addedWords = [], onMarkStoryFinished, isFinished }) {
  const [quizData, setQuizData] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);
  const [showFinishModal, setShowFinishModal] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const [selectedOptionText, setSelectedOptionText] = useState(null);
  

  const language = "de"; // TEMP

  useEffect(() => {
    if (!quizUrl) return;
    const storage = getStorage();
    getBytes(ref(storage, quizUrl))
      .then((bytes) => JSON.parse(new TextDecoder().decode(bytes)))
      .then((data) => setQuizData(data))
      .catch(() => setQuizData([]));
  }, [quizUrl]);

  if (!quizData.length) return <p>❌ Não há quiz disponível para esta história.</p>;

  const question = quizData[current];
  const displayWord = selectedOptionText || hoveredOption || "";
  const formattedQuestion = question.question.replaceAll(
    "__________",
    `<span class='blank'>${displayWord}</span>`
  );

  function handleNext() {
    if (selected === null) return;
    if (selected === question.answer) setScore(score + 1);

    if (current + 1 < quizData.length) {
      setCurrent(current + 1);
      setSelected(null);
      setHoveredOption(null);
      setSelectedOptionText(null);
    } else {
      setFinished(true);
    }
  }

  function handleRestart() {
    setCurrent(0);
    setSelected(null);
    setScore(0);
    setFinished(false);
  }

  if (finished) {
    return (
      <div className="quiz-result-container">
        <div className="quiz-score-circle">
          <span className="quiz-score-text">
            {score}/{quizData.length}
          </span>
        </div>
        <h2 className="quiz-finished-title">Quiz Concluído!</h2>
        <p className="quiz-finished-subtitle">
          Você acertou {score} de {quizData.length} perguntas
        </p>

        {/* ✅ Buttons container */}
        <div className="quiz-result-buttons">
          <button className="quiz-button grey" onClick={handleRestart}>
            Tentar novamente
          </button>

          <button
            className="quiz-button"
            onClick={() => {
              // ✅ Mark story as finished if not already
              if (onMarkStoryFinished && !isFinished) {
                onMarkStoryFinished();
              }
              // 🎉 Open modal
              setShowFinishModal(true);
            }}
          >
            Finalizar
          </button>

        </div>

        {/* 🎉 Celebration modal */}
        {showFinishModal && (
          <StoryFinishModal
            story={story}
            score={score}
            total={quizData.length}
            savedWords={addedWords.length}
            onClose={() => setShowFinishModal(false)}
          />
        )}
      </div>
    );
  }

  // ✅ Quiz questions
  return (
    <div className="quiz-container">
      <div className="quiz-header">
        <span className="quiz-progress-text">
          Pergunta {current + 1} de {quizData.length}
        </span>
        <div className="quiz-progress-bars">
          {quizData.map((_, idx) => (
            <div
              key={idx}
              className={`quiz-bar ${
                idx < current ? "done" : idx === current ? "active" : ""
              }`}
            />
          ))}
        </div>
      </div>

      <h2
        className="quiz-question"
        dangerouslySetInnerHTML={{ __html: formattedQuestion }}
      ></h2>

      <div className="quiz-options">
        {question.options.map((option, idx) => (
          <div
            key={idx}
            onClick={() => {
              setSelected(idx);
              setSelectedOptionText(option);
            }}
            onMouseEnter={() => setHoveredOption(option)}
            onMouseLeave={() => setHoveredOption(null)}
            className={`quiz-option ${selected === idx ? "selected" : ""}`}
          >
            {option}
          </div>
        ))}
      </div>

      <button
        className={`quiz-button ${selected === null ? "disabled" : ""}`}
        onClick={handleNext}
        disabled={selected === null}
      >
        {current + 1 === quizData.length ? "Finish" : "Próximo"}
      </button>
    </div>
  );
}
